/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "../styles/tailwind.css"
import "../styles/layout.scss"
import Header from "./header"
import StyledContainer from './Container'

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query GlobalSiteQuery {
      site {
        siteMetadata {
          title
          author
        }
      }
      allMarkdownRemark(limit: 1, sort: {fields: frontmatter___date, order: DESC}, filter: {frontmatter: {templateKey: {eq: "storiesTemplate"}}}) {
        edges {
          node {
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  return (
    <StyledContainer className="Container">
      <Header siteTitle={data.site.siteMetadata.title} storiesLink={data.allMarkdownRemark.edges[0].node.fields.slug} />
      <main>{children}</main>
      <footer>
        © CAN Borneo {new Date().getFullYear()}, Built by <a href="https://www.joshunwin.com/" target='_blank' rel="noopener noreferrer">{data.site.siteMetadata.author}</a>
      </footer>
    </StyledContainer>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
